import { FeatureDefinition } from '../entities';

export const mediaBrandsExperiment = 'ab_gs_wp_offer_change-media-brands-on-legal_mo_0326';

export enum MediaBrandsExperimentGroups {
  CONTROL = 'control',
  TEST = 'test',
}

export const mediaBrandsExperimentConfig: FeatureDefinition = {
  defaultValue: MediaBrandsExperimentGroups.CONTROL,
};
